import { useEffect, useState } from 'react'

const useBreakpoint = () => {
  const [width, setWidth] = useState<number>(0)
  const [height, setHeight] = useState<number>(0)
  const [isMobile, setIsMobile] = useState<boolean>(false)

  useEffect(() => {
    const handleSize = () => {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
      setIsMobile(window.innerWidth < 768)
    }

    handleSize()
    window.addEventListener('resize', handleSize)

    return () => window.removeEventListener('resize', handleSize)
  }, [])

  return { width, height, isMobile }
}

export default useBreakpoint
